var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatalan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 8.33325H0.5V39.6666H47.5V8.33325Z",
    fill: "#FFD700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 13.5554H47.5H0.5ZM47.5 20.5184H0.5H47.5ZM0.5 27.4813H47.5H0.5ZM47.5 34.4443H0.5H47.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 11.8147H47.5V15.2962H0.5V11.8147ZM47.5 22.2591H0.5V18.7777H47.5V22.2591ZM0.5 25.7406H47.5V29.2221H0.5V25.7406ZM0.5 32.7036H47.5V36.1851H0.5V32.7036Z",
    fill: "#CC0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalan);
export default __webpack_public_path__ + "static/media/Catalan.0f74c5da.svg";
export { ForwardRef as ReactComponent };